// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2tfry","boxTitle":"Qualiphy_boxTitle__1ShMy","box":"Qualiphy_box__H1bAd","toggleWrap":"Qualiphy_toggleWrap__3fFtL"};